module.exports = __webpack_public_path__ + "static/media/transfer students.94909fe0.svg";